// eslint-disable
// @ts-nocheck
import cn from 'classnames'
import { FC } from 'react'

import { useSafetyTranslation } from 'cng-common/features/translations'
import { Translation } from 'cng-common/features/translations/components/translation'
import { DatePicker } from 'core-components/library/datepicker'
import { Tooltip } from 'core-components/library/tooltip'

import { useFormField } from '../../hooks/useFormField'
import { ReadOnlyField } from '../readOnlyField'

import { IFormDatePickerProps } from './models'

import styles from './FormDatePicker.module.scss'

export const FormDatePicker: FC<IFormDatePickerProps> = ({
  field,
  formKey,
  label = '',
  dateFormat,
  defaultValue,
  className,
  isDisabled,
  isRequired,
  isReadOnly,
  isVisible = true,
  onChange,
  onBlur,
  onValidate,
  validationType,
  hasClearButton,
  fromDate,
  placeholder,
}) => {
  const { handleChange, value, validationMessage, isModified } = useFormField<Date>({
    field,
    formKey,
    defaultValue,
    onChange,
    onValidate,
    isDisabled,
    isRequired,
    isReadOnly,
    isVisible,
    onBlur,
    validationType,
  })

  const t = useSafetyTranslation()
  const translatedPlaceholder = placeholder ? t(placeholder) : undefined

  const onChangeHandler = (value: unknown) => {
    if (value) handleChange(value)
    else handleChange('')
  }

  if (isReadOnly) {
    return <ReadOnlyField label={label} value={value} />
  }

  if (isVisible) {
    return (
      <div className={styles.validationContainer}>
        <Tooltip disabled={!validationMessage} tipContent={() => <>{validationMessage}</>}>
          <DatePicker
            classes={{
              controlClasses: {
                root: cn(className, {
                  [styles.modified]: isModified,
                  [styles.required]: isRequired && Boolean(label),
                  [styles.invalid]: validationMessage,
                }),
              },
            }}
            label={label && <Translation text={label} span />}
            mode="single"
            onChange={onChangeHandler}
            dateFormat={dateFormat}
            value={value}
            clearButtonVisible={hasClearButton}
            fromDate={fromDate}
            disabled={isDisabled}
            placeholder={translatedPlaceholder}
          />
        </Tooltip>
      </div>
    )
  }

  return null
}
